import { render, staticRenderFns } from "./table-single.vue?vue&type=template&id=0b85dd00&scoped=true&"
import script from "./table-single.vue?vue&type=script&lang=js&"
export * from "./table-single.vue?vue&type=script&lang=js&"
import style0 from "./table-single.vue?vue&type=style&index=0&id=0b85dd00&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b85dd00",
  null
  
)

export default component.exports